import React from "react";
import {Link} from "react-router-dom";
import {useQuery} from "../../utils/router"
import {serializeQueryString} from "../../utils/string";

export function Pagination({currentPage, totalPages}) {
    const beginPage = Math.max(Math.min(currentPage-2, totalPages-4), 1);
    const endPage = Math.min(beginPage+4, totalPages);
    let query = useQuery();
    query = Object.fromEntries(query);

    return (
        <nav className="pagination " role="navigation" aria-label="Pagination Navigation">
            <ul className="no-bullet">
                {currentPage > 1 &&
                    <li>
                        <a className="prev" href={`/search?${serializeQueryString({ ...query, p: currentPage-1 })}`} aria-label="Go to Previous Page">
                            <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.5 1l-5 5 5 5" stroke="currentColor"/>
                            </svg>
                        </a>
                    </li>
                }
                {Array.from(Array(endPage-beginPage+1), (e, i) => {
                    let page = beginPage+i;
                    return <li key={page}>
                        <a href={`/search?${serializeQueryString({ ...query, p: page })}`} {...(page === currentPage ? { "aria-current": true } : {})}>{page}</a>
                    </li>
                })}
                {currentPage < totalPages &&
                    <li>
                        <a className="next" href={`/search?${serializeQueryString({ ...query, p: currentPage+1 })}`} aria-label="Go to Next Page">
                            <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M.5 11l5-5-5-5" stroke="currentColor"/>
                            </svg>
                        </a>
                    </li>
                }
            </ul>
        </nav>
    );
}
